module.exports = __webpack_public_path__ + "0c7ee64e7eb881c587b38c82b85f5d18.jpg";